/* ============================================================================
   atom-icon-tooltip.js — tap-to-reveal feature-icon descriptions
   ----------------------------------------------------------------------------
   Tap (or keyboard-activate) a feature icon → its description appears in a
   small popover for ~4.5s, then fades away. Also dismisses on a second tap,
   an outside click, Esc, or scroll.

   Text comes from the data-icon-tip attribute the atom-svg-icon snippet writes
   from the shop metafield atom_icons.tooltips (operator-editable in Switchboard).
   Dependency-free. Safe DOM only (textContent, no innerHTML).

   Accessibility fix 2026-06-07: role="button" is now on an inner <span> wrapper
   (not the <li>) to satisfy WCAG list-child requirements (axe: listitem).
   ========================================================================== */
(function () {
  'use strict';

  var icons = document.querySelectorAll('.buybox-feat-icon[data-icon-tip]');
  if (!icons.length) return;

  var pop = document.createElement('div');
  pop.className = 'atom-icon-tip';
  pop.setAttribute('role', 'status');
  pop.setAttribute('aria-live', 'polite');
  document.body.appendChild(pop);

  var current = null, hideTimer = null;

  function hide() {
    clearTimeout(hideTimer);
    pop.classList.remove('is-visible');
    if (current) { current.setAttribute('aria-expanded', 'false'); current = null; }
  }

  function show(trigger, text) {
    clearTimeout(hideTimer);
    pop.textContent = text;
    pop.classList.add('is-visible');                 // make measurable
    var r = trigger.getBoundingClientRect();
    var pr = pop.getBoundingClientRect();
    var left = r.left + r.width / 2 - pr.width / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - pr.width - 8));
    var top = r.top - pr.height - 10;
    if (top < 8) top = r.bottom + 10;                // flip below if no room above
    pop.style.left = Math.round(left) + 'px';
    pop.style.top = Math.round(top) + 'px';
    current = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    hideTimer = setTimeout(hide, 4500);              // "a few seconds, then disappear"
  }

  Array.prototype.forEach.call(icons, function (icon) {
    var item = icon.closest('.buybox-feat') || icon;
    var tip = icon.getAttribute('data-icon-tip');
    if (!tip || item.dataset.tipBound) return;
    item.dataset.tipBound = '1';
    item.classList.add('has-icon-tip');

    // Wrap item children in a <span role="button"> so the <li> stays a plain
    // list-item (valid child of <ul>) while the inner span is the interactive control.
    var wrapper = document.createElement('span');
    wrapper.setAttribute('role', 'button');
    wrapper.setAttribute('tabindex', '0');
    wrapper.setAttribute('aria-expanded', 'false');
    wrapper.className = 'buybox-feat-trigger';
    var label = item.querySelector('.buybox-feat-label');
    wrapper.setAttribute('aria-label', (label ? label.textContent.trim() : 'Feature') + ', show details');

    // Move existing children into wrapper
    while (item.firstChild) {
      wrapper.appendChild(item.firstChild);
    }
    item.appendChild(wrapper);

    function activate(e) {
      e.preventDefault();
      e.stopPropagation();
      if (current === wrapper) { hide(); return; }      // second tap closes
      show(wrapper, tip);
    }
    wrapper.addEventListener('click', activate);
    wrapper.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') activate(e);
    });
  });

  document.addEventListener('click', function () { if (current) hide(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && current) hide(); });
  window.addEventListener('scroll', function () { if (current) hide(); }, { passive: true });
  window.addEventListener('resize', function () { if (current) hide(); });
})();
